// extracted by mini-css-extract-plugin
export default {"form":"style_form__If7Gj","toolbar":"style_toolbar__ej4EB"};